import { apolloClient } from '@/services/apollo';
import { getUserDetail } from '@/gql/Login.gql';

var currentUser;

function loggedIn(){
    return (!!localStorage.token);
}

function parseJwt (token) {
    var base64Url = token.split('.')[1];
    var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    var jsonPayload = decodeURIComponent(atob(base64).split('').map(function(c) {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
    }).join(''));
    return JSON.parse(jsonPayload);
}

async function callUser() {
    if(currentUser) {
        return currentUser;
    } else if(localStorage.token) {
        var jwt = parseJwt(localStorage.token);
        let userData = await apolloClient.query({
            query: getUserDetail,
            variables: { id:jwt.sub }
        }).then(({ data }) => {
            return data.userDetail;
        });
        currentUser = userData;
        return userData
    } else {
        return null;
    }
}

export default {
    user : callUser,
    loggedIn: loggedIn
}
